import { render, staticRenderFns } from "./lb.vue?vue&type=template&id=40304468&scoped=true&"
import script from "./lb.vue?vue&type=script&lang=js&"
export * from "./lb.vue?vue&type=script&lang=js&"
import style0 from "./lb.vue?vue&type=style&index=0&id=40304468&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40304468",
  null
  
)

export default component.exports